export const inviteAFriendSchema = {
  email: {
    required: 'Mandatory e-mail field',
    invalid: 'Invalid e-mail',
    alreadyFriends: 'Already friends',
    requestSent: 'Request already sent'
  }
};
